(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('yield-curve-point', {
            parent: 'entity',
            url: '/yield-curve-point',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.yieldCurvePoint.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-points.html',
                    controller: 'YieldCurvePointController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('yieldCurvePoint');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('yield-curve-point-detail', {
            parent: 'yield-curve-point',
            url: '/yield-curve-point/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.yieldCurvePoint.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-detail.html',
                    controller: 'YieldCurvePointDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('yieldCurvePoint');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'YieldCurvePoint', function($stateParams, YieldCurvePoint) {
                    return YieldCurvePoint.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'yield-curve-point',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('yield-curve-point-detail.edit', {
            parent: 'yield-curve-point-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-dialog.html',
                    controller: 'YieldCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['YieldCurvePoint', function(YieldCurvePoint) {
                            return YieldCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('yield-curve-point.new', {
            parent: 'yield-curve-point',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-dialog.html',
                    controller: 'YieldCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                date: null,
                                str: null,
                                deltaPeriods: null,
                                discount: null,
                                zeroRate: null,
                                forwardRate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('yield-curve-point', null, { reload: 'yield-curve-point' });
                }, function() {
                    $state.go('yield-curve-point');
                });
            }]
        })
        .state('yield-curve-point.edit', {
            parent: 'yield-curve-point',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-dialog.html',
                    controller: 'YieldCurvePointDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['YieldCurvePoint', function(YieldCurvePoint) {
                            return YieldCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('yield-curve-point', null, { reload: 'yield-curve-point' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('yield-curve-point.delete', {
            parent: 'yield-curve-point',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-point/yield-curve-point-delete-dialog.html',
                    controller: 'YieldCurvePointDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['YieldCurvePoint', function(YieldCurvePoint) {
                            return YieldCurvePoint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('yield-curve-point', null, { reload: 'yield-curve-point' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
